import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Upload from '../../organisms/UploadCustom';
import Upload2 from '../../organisms/UploadCustom/index3.js';
import { reduxForm, getFormValues, formValueSelector } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import UserHeader from '../../organisms/UserHeader';
import * as common from '../../common';
import conf from '../../../config/config.js';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 4px 16px 4px',
    backgroundColor: '#fafafa',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',     
  },
  fields: {
    margin: '0px 10px 15px 10px',
  },
  fieldsPostal: {
    margin: '0px 0px 15px 10px',
    width: '90%',
  },
  fields3: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 4px 16px 4px',
    margin: '0',
  },
  fields4: {
    margin: '0px 1px 15px 10px',
    width: '200px',
  },
  fieldsPoleNum: {
    margin: '0px 1px 15px 10px',
    width: '53px',
    alignItems: 'right',
    textAlign: 'right',
    fontSize: '0.9em',
  },
  fieldsPoleNum2: {
    margin: '0px 1px 15px 0px',
    width: '68px',
  },
  fieldsPoleNum3: {
    margin: '0px 1px 15px 0px',
    width: '53px',
  },
  fieldsPoleChar: {
    margin: '0px 1px 15px 0px',
    width: '50px',
  },
  typography:{
    margin: '0 0 0 40px'
  },
  typography3:{
    margin: '10px 10px -10px 16px'
  },
  typography4:{
    margin: '10px 10px 0 16px'
  },
  textFieldDate: {
    margin: '0px 10px 15px 10px',
    width: '42%',
    minWidth: '240px',
  },
  button: {
    marginTop: '20px',
    marginLeft: '80px',
    marginRight: '80px',
  },
  formControl: {
    margin: '10px 20px 10px 20px',
  },
  formControl2: {
    margin: '10px 20px 0 20px',
  },
  formControl3: {
    margin: '-21px 20px 0 0',
    paddingLeft:"25px",
  },
  upload: {
    margin: '10px 20px 0px 10px',
    alignItems: 'center',
  },
  formLabel: {
    color: "#212121",
    margin: "0 0 5px -5px"
  },
  formLabel2: {
    color: "#212121",
    width: '30px',
  },
  formLabel3: {
    margin: '0px 10px 0px 7px',
    width: '50px',
    textAlign: "center",
  },
  formLabel4: {
    margin: '0px 10px 0px 0px',
    width: '35px',
    textAlign: "center",
  },
  formLabel5: {
    margin: '0px 10px 0px 0px',
    width: '45px',
    textAlign: "center"
  },
  formLabel6: {
    margin: '0px 10px 0px 0px',
    width: '68px',
    textAlign: "center",
  },  
  dateMark: {
    marginTop: "22px",
    fontSize: "1.2em",
  },
  typographySec: {
    color: "#d50000",
    border: "solid 1px #d50000",
    margin: '10px 10px 0 10px',
    padding: '0 0 0 5px',
    borderRadius: "0.1em",
    fontSize: "0.8em",
  },
  typographySecBlue: {
    color: "#2f5ff5",
    border: "solid 1px #2f5ff5",
    margin: '10px 10px 0 10px',
    padding: '0 0 0 5px',
    borderRadius: "0.1em",
    fontSize: "0.8em",
  },
  typographySecPole: {
    color: "#d50000",
    border: "solid 1px #c0c0c0",
    margin: '10px 10px 0 10px',
    padding: '0 0 0 5px',
    borderRadius: "0.3em",
    fontSize: "0.9em",
    height: "auto",
    width: "auto",
    maxWidth: "700px",
  },
  typographySecPoleWarn: {
    color: "#d50000",
    border: "solid 1px #f44336",
    margin: '10px 10px 0 10px',
    padding: '0 0 0 5px',
    borderRadius: "0.3em",
    fontSize: "0.9em",
    height: "auto",
    width: "auto",
    minHeight: "130px",
    maxWidth: "700px",
  },
  typographyWarn: {
    color: "#ffffff",
    backgroundColor: "#e60033",
    borderRadius: '99px',
    border: "solid 1px #e60033",
    margin: '10px 10px 0 10px',
    padding: '7px 4px 4px 8px',
    fontSize: "0.8em",
  },
  container1: {
    fontSize: "0.5em",
    margin: "40px 0 0 5px",
    width: '10px',
  },
  containerGridItem: {
    margin: "0 0 0 0",
    marginRight: "0",
    padding: '0',
  },
  label2: {
    padding: '0 0 0 10px',
    width: '100%',
  },
  label3: {
    width: '100%',
    color: "#eef3f8",
    fontSize: "1.0em"
  },
  serchbutton: {
    marginTop: '10px',
    marginLeft: '-5px',
  },
});

const renderTextField = ({
  input,
  label,
  meta: { touched, error, valid },
  ...custom
}) => (
  <TextField
    label={label}
    helperText={touched && error}
    error={touched && !valid}
    {...input}
    {...custom}
  />
);

renderTextField.propTypes = {
  input: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  label: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  meta: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

class WorkRequestSeparation extends React.Component {

  state = {
    ApplicationFormDatas: [],
    PhotoDatas: [],
  };
  
  onChange = event => {
    const { name, value } = event.target;

    this.setState({
      [name]: value
    });
  }

  // 登録確認
  doWorkRequestSeparation = () => {

    const { doOpenDialog} = this.props;

    if (this.state.ApplicationFormDatas.length === 0) {
      const dialog = {
        type: 'ok', // '閉じる'のみ表示
        title: '',
        message: 'workRequestSeparation.dialog.error.applicationform',
      };
      doOpenDialog(dialog);
      return;
    }

    if (this.state.PhotoDatas.length === 0) {
      const dialog = {
        type: 'ok', // '閉じる'のみ表示
        title: '',
        message: 'workRequestSeparation.dialog.error.imagefile',
      };
      doOpenDialog(dialog);
      return;
    }

    const dialog = {
      type: 'okcancel', // 「確認」と「キャンセル」を表示
      title: '',
      message: 'workRequestSeparation.dialog.inquiry',
      action: this.doAction
    };
    doOpenDialog(dialog);
  }

  // 切離登録処理
  doAction = async() => {

    console.log("#切離申込#");
    const { doWorkRequestSeparationAction, doOpenDialog} = this.props;
    try {
      console.log("pdf:" + this.state.ImagePdfDatas);
      const result = await doWorkRequestSeparationAction(this.state.ApplicationFormDatas, this.state.PhotoDatas);
      console.log(result);
      if (result === "00000") {
        // 正常
        const dialog = {
          type: 'ok', // '閉じる'のみ表示
          title: '',
          message: 'workRequestSeparation.dialog.finish',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      } else if (result === "20500" || result === "20501") {
        // 20500：お客様情報取得失敗(cognitoからの取得)
        // 20501：引込線申込 失敗
        const dialog = {
          type: 'ok', // '閉じる'のみ表示
          title: '',
          message: 'workRequestSeparation.dialog.error.failure',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      } else if (result === "ERROR_UPLOAD") {
        // ファイルアップロード失敗(メッセージを表示してメニュー画面表示)
        const dialog = {
          type: 'ok', // '閉じる'のみ表示
          title: '',
          message: 'workRequestSeparation.dialog.error.failure.upload',
          action: this.onClickBack
        };
        doOpenDialog(dialog);
      }
      else {
        // その他エラー
        const dialog = {
          type: 'error', // '閉じる'のみ表示
          title: 'system.message.error.title',
          message: 'system.message.error.context',
        };
        doOpenDialog(dialog);
      }
    }
    catch (err) {
      console.log(`エラー: ${err}`);
      // その他エラー
      const dialog = {
          type: 'error', // '閉じる'のみ表示
          title: 'system.message.error.title',
          message: 'system.message.error.context',
      };
      doOpenDialog(dialog);
    }

  };

  // 戻る(メニュー画面に遷移)
  onClickBack = () => {
    this.props.history.push('/workMenu');
  };

  // 申込用紙アップロード
  setApplicationFiles = (e) => {
    this.setState({ApplicationFormDatas: e});
  }

  // 画像ファイルアップロード
  setPhotoFiles = (e) => {
    this.setState({PhotoDatas: e});
  }

render() {
    const { classes, handleSubmit} = this.props;

    return (
      <div className={classes.root}>
      <form noValidate autoComplete="off" className={classes.root}>
      <UserHeader />

        {/* 資料アップロード */}
        <Typography variant="subtitle1" className={classes.typography3}>引込線切離の申込みは、申込用紙にて受付けております。</Typography>
        <Typography variant="subtitle1" className={classes.typography3}>申込用紙をダウンロードして、必要事項を記入の上、アップロードしてください。</Typography>
        <Typography variant="subtitle2" display="inline" className={classes.typographySecBlue}><FormattedMessage id={'workRequestSeparation.title.applicationform'}/></Typography>
        <p style={{fontSize: 5, height: 1}}></p>
        <Typography variant="body1" className={classes.typographyValue} style={{paddingLeft:"20px"}}>
              ・<u style={{color:'#0000ff', cursor:'hand'}}>
                <a target="_blank" rel="noopener noreferrer" href={conf.APPLICATIONFORM_WORD_URL}>
                  引込線切離申込書（Word）ダウンロード
                  </a>
              </u>             
        </Typography>
        <Typography variant="body1" className={classes.typographyValue} style={{paddingLeft:"20px"}}>
              ・<u style={{color:'#0000ff', cursor:'hand'}}>
                <a target="_blank" rel="noopener noreferrer" href={conf.APPLICATIONFORM_PDF_URL}>
                  引込線切離申込書（PDF）ダウンロード
                </a>
              </u>             
        </Typography>
        <Typography variant="body1" className={classes.typographyValue} style={{paddingLeft:"20px"}}>
              ・<u style={{color:'#0000ff', cursor:'hand'}}>
                <a target="_blank" rel="noopener noreferrer" href={conf.APPLICATIONFORM_EXAMPLE_URL}>
                引込線切離申込書（記入例）
                </a>
              </u>             
        </Typography>
        <Fragment>
          <div style={{display: "flex", paddingLeft:"20px"}}>
            <Upload
              id="applicationFile"
              key="applicationFile"
              componentId="applicationFile"
              maxFileCount={10}
              maxFileSize={10485760}
              previewFlag={false}
              previewWidth="35%"
              acceptFileType=".pdf,.jpeg,.png,.gif"
              fileSetHandler={this.setApplicationFiles}
            />
            </div>
        </Fragment>
        <br/>

        {/* 画像ファイルアップロード */}
        <Typography variant="subtitle1" className={classes.typography3}>現在の状況がわかる画像ファイルをアップロードして下さい。</Typography>
        <Typography variant="subtitle2" display="inline" className={classes.typographySecBlue}><FormattedMessage id={'workRequestSeparation.title.imagefile'}/></Typography>
        <p style={{fontSize: 5, height: 1}}></p>
        <Typography variant="body1" className={classes.typographyValue} style={{paddingLeft:"20px"}}>
              ・<u style={{color:'#0000ff', cursor:'hand'}}>
                <a target="_blank" rel="noopener noreferrer" href={conf.IMAGEFILE_SAMPLE_URL}>
                 画像ファイルサンプル
                </a>
              </u>
        </Typography>        
        <Fragment>
          <div style={{display: "flex", paddingLeft:"20px"}}>
            <Upload2
              id="photoFile"
              key="photoFile"
              componentId="photoFile"
              maxFileCount={10}
              maxFileSize={10485760}
              previewFlag={true}
              previewWidth="35%"
              acceptFileType=".pdf,.jpeg,.png,.gif"
              fileSetHandler={this.setPhotoFiles}
            />
          </div>
        </Fragment>
        <br/>

{/* ボタン */}
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          size="large"
          onClick={handleSubmit(this.doWorkRequestSeparation)}
          type="submit"
        >
          <span><FormattedMessage id={'common.btn.application'}/></span>
        </Button>
        <Button
          variant="outlined"
          color="primary"
          className={classes.button}
          size="large"
          onClick={this.onClickBack}
        >
          <span><FormattedMessage id={'common.btn.back'}/></span>
        </Button>

      </form>
      </div>
    );
  }
}

const FORM_NAME = "WorkRequestSeparation";

WorkRequestSeparation.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

const mapStateToProps = state => ({
  initialValues: {
    OrderCategory__c:"引込線切離",
  },
});

WorkRequestSeparation = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount : true,
  enableReinitialize: true,
})(connect(state => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(WorkRequestSeparation));

export default withStyles(styles)(
  connect(
    mapStateToProps
  )(injectIntl(WorkRequestSeparation))
);
